import { AddOutline18Icon } from "@vygruppen/spor-icon-react";
import CreateInternalMessageModal from "features/CenterContent/RoleContent/InternalMessage/CreateInternalMessageModal";
import EditInternalMessageModal from "features/CenterContent/RoleContent/InternalMessage/EditInternalMessageModal";
import { CreateTrainInfoModal } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/CreateTrainInfoModal";
import { useTrainInformationFromURLParams } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/useTrainInformation";
import { useTrainInternalMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/useTrainInternalMessages";
import { getOpenStates } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/utils";
import { DetailsParams } from "features/CenterContent/VehicleDetails/TrainDetails/TrainDetails";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ResponsiveButton } from "shared/components/buttons/ResponsiveButton";
import { FailureMessage } from "shared/components/feedback/FailureMessage/FailureMessage";
import { Flex, Text } from "shared/components/Spor";
import { NoteOutline18Icon } from "shared/icons/NoteIcon";
import { hideOnWidthStyle } from "shared/utils/hideOnWidth";
import { useDropsRole } from "stores/useDropsRole";
import styled from "styled-components";

const newTrainInfoButtonBreakpoint = 350;
const newInternalMsgButtonBreakpoint = 475;
const TrainInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
  width: 100%;

  ${hideOnWidthStyle(newTrainInfoButtonBreakpoint)}
  ${hideOnWidthStyle(newInternalMsgButtonBreakpoint)}
`;

export const OperationalTrainInfoHeader = () => {
  const { trainNumber, trainDate, countryCode } = useParams<DetailsParams>();
  const internalMessagesInformation = useTrainInternalMessage();
  const internalMessagesUuid = internalMessagesInformation.data?.[0]?.uuid;
  const trainInformation = useTrainInformationFromURLParams();
  const { t } = useTranslation();

  const trainInfoWithOpenState = getOpenStates(trainInformation.data);

  const { isVaktleder, isLokleder, isDriftledningen } = useDropsRole();
  const showInSweden = isDriftledningen() && countryCode === "SE";

  const [internalMessageModalOpen, setInternalMessageModalOpen] =
    useState<boolean>(false);
  const [trainInfoModalOpen, setTrainInfoModalOpen] = useState<boolean>(false);

  if (
    trainNumber === undefined ||
    trainDate === undefined ||
    countryCode === undefined
  ) {
    return (
      <FailureMessage
        customMessage={t(
          "Kunne ikke hente tognummer eller dato for dette toget.",
        )}
      />
    );
  }

  return (
    <TrainInfoWrapper>
      <Flex gap="12px" justifyContent="flex-end" alignItems="center" w="100%">
        <Text variant="xs" fontWeight={600} mr="auto">
          {t("Hendelse", { count: 0 })}
        </Text>
        {isVaktleder() && (
          <ResponsiveButton
            breakpoint={newInternalMsgButtonBreakpoint}
            variant="tertiary"
            size="sm"
            onClick={() => setInternalMessageModalOpen(true)}
            leftIcon={<NoteOutline18Icon />}
            disabled={internalMessagesInformation.status !== "success"}
          >
            {t("Intern melding")}
          </ResponsiveButton>
        )}
        {(isVaktleder() || isLokleder() || showInSweden) && (
          <ResponsiveButton
            breakpoint={newTrainInfoButtonBreakpoint}
            variant="primary"
            size="sm"
            onClick={() => setTrainInfoModalOpen(true)}
            leftIcon={<AddOutline18Icon />}
          >
            {t("Ny hendelse")}
          </ResponsiveButton>
        )}
      </Flex>
      {internalMessageModalOpen &&
        (internalMessagesUuid ? (
          <EditInternalMessageModal
            uuid={internalMessagesUuid}
            setModalOpen={setInternalMessageModalOpen}
          />
        ) : (
          <CreateInternalMessageModal
            train={{
              identifier: trainNumber,
              nominalDate: trainDate,
              countryCode, // TODO: CountryCode should not be hardcoded
            }}
            setModalOpen={setInternalMessageModalOpen}
          />
        ))}
      {trainInfoModalOpen && (
        <CreateTrainInfoModal
          train={{
            identifier: trainNumber,
            nominalDate: trainDate,
            countryCode, // TODO: CountryCode should not be hardcoded
          }}
          setModalOpen={setTrainInfoModalOpen}
          trainInfoWithOpenState={trainInfoWithOpenState}
        />
      )}
    </TrainInfoWrapper>
  );
};
